export function lastIbanDigits(iban?: string, numberOfDigits: number = 4) {
  if (!iban || iban.length < numberOfDigits) return '';
  return `●●●● ${iban.substring(iban.length - numberOfDigits)}`;
}

export function maskedIban(iban?: string) {
  if (!iban || iban.length < 4) return '';
  return `${iban.substring(0, 2)}●● ●●●● ●●●● ●●●● ●●●● ${iban.substring(iban.length - 4)}`;
}
